<div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-8 " [class.tw-pt-8]="mobileCheck">
    <tilby-magic-form [form]="data.form"/>
    <div *ngIf="qrCode" id="qr-code" class="tw-flex tw-items-center tw-justify-center tw-flex-none tw-w-72 tw-h-72 tw-bg-blue-500 tw-rounded-3xl tw-mx-auto">
        <qrcode [qrdata]="qrCode" [width]="220" [errorCorrectionLevel]="'M'" cssClass="tw-rounded-3xl"></qrcode>
    </div>
</div>

